import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { DOCS } from '@constants/routes';

import { WebhooksEvents } from './constants';
import getDescriptionUrlById from './helper';

const OverviewPage = lazy(
  () => import('@features/docs/pages/overview/Overview')
);
const APIReference = lazy(
  () => import('@features/docs/pages/api-reference/ApiReference')
);
const ApiKeys = lazy(() => import('@features/docs/pages/api-keys/ApiKeys'));
const Webhooks = lazy(() => import('@features/docs/pages/webhooks/Webhooks'));
const WebhookReference = lazy(
  () => import('@features/docs/pages/webhook-reference/WebhookReference')
);

const routesConfig: {
  [key: string]: { component: React.ElementType; props?: Record<string, any> };
} = {
  [DOCS.OVERVIEW]: { component: OverviewPage },
  [DOCS.API_KEYS]: { component: ApiKeys },
  [DOCS.WEBHOOKS]: { component: Webhooks },
  [DOCS.API_REFERENCE]: { component: APIReference },
  [DOCS.CREATE_PAYMENT_ORDER]: { component: APIReference },
  [DOCS.GET_PAYMENT_ORDER_BY_ORDER_ID]: { component: APIReference },
  [DOCS.GET_PAYMENT_ORDER_BY_REFERENCE_ID]: { component: APIReference },
  [DOCS.CANCEL_PAYMENT_ORDER]: { component: APIReference },
  [DOCS.CREATE_SETTLEMENT_ACCOUNT]: { component: APIReference },
  [DOCS.GET_SETTLEMENT_ACCOUNT_BY_REFERENCE_ID]: { component: APIReference },
  [DOCS.PAYMENT_ORDER_REQUEST_SCHEMA]: { component: APIReference },
  [DOCS.PAYMENT_ORDER_RESPONSE_SCHEMA]: { component: APIReference },
  [DOCS.ERROR_RESPONSE_SCHEMA]: { component: APIReference },
  [DOCS.SETTLEMENT_ACCOUNT_REQUEST_SCHEMA]: { component: APIReference },
  [DOCS.SETTLEMENT_ACCOUNT_RESPONSE_SCHEMA]: { component: APIReference },
  [DOCS.WEBHOOK_PAYMENT]: {
    component: WebhookReference,
    props: { yamlUrl: getDescriptionUrlById(WebhooksEvents, 'payment-order') }
  },
  [DOCS.WEBHOOK_ACCOUNT_SETTLEMENT]: {
    component: WebhookReference,
    props: {
      yamlUrl: getDescriptionUrlById(WebhooksEvents, 'settlement-account')
    }
  }
};

const DocsRoutes: RouteObject[] = Object.entries(routesConfig).map(
  ([path, entry]) => {
    const { component: Component, props } = entry;
    return {
      path,
      element: <Component {...props} />
    };
  }
);

export default DocsRoutes;
